import { render, staticRenderFns } from "./TsTable.vue?vue&type=template&id=70393d3a&scoped=true&"
import script from "./TsTable.vue?vue&type=script&lang=ts&"
export * from "./TsTable.vue?vue&type=script&lang=ts&"
import style0 from "./TsTable.vue?vue&type=style&index=0&id=70393d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70393d3a",
  null
  
)

export default component.exports